import { useCallback } from 'react';
import useStats from 'src/hooks/useStats';
import { EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';

function useStatsEvents() {
  const { updateStats, updateEvents } = useStats();

  const createStatsListeners = useCallback(() => {
    ApplicationService.player?.addEventListeners([EVENT_TYPES.LOADED_METADATA, EVENT_TYPES.TIME_UPDATE], updateStats);
    ApplicationService.player?.addEventListeners(
      [EVENT_TYPES.PLAY, EVENT_TYPES.PAUSE, EVENT_TYPES.SEEKING, EVENT_TYPES.WAITING],
      updateEvents,
    );
  }, []);

  return { createStatsListeners };
}

export default useStatsEvents;
